import React, { useEffect, useRef, useState } from "react";
import { Battery /* , Wifi, Smartphone */ } from "lucide-react";

const LiveCameraFeed = () => {
  const videoRef = useRef(null);
  const [batteryInfo, setBatteryInfo] = useState(null);
  /* const [networkType, setNetworkType] = useState(null); */

  useEffect(() => {
    const getCameraStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (error) {
        console.error("Error accessing the camera: ", error);
      }
    };

    getCameraStream();

    if (navigator.getBattery) {
      navigator.getBattery().then((battery) => {
        updateBatteryInfo(battery);

        battery.addEventListener("levelchange", () =>
          updateBatteryInfo(battery)
        );
        battery.addEventListener("chargingchange", () =>
          updateBatteryInfo(battery)
        );
      });
    }

    /* if (navigator.connection) {
      setNetworkType(
        navigator.connection.type || navigator.connection.effectiveType
      );
      navigator.connection.addEventListener("change", () => {
        setNetworkType(
          navigator.connection.type || navigator.connection.effectiveType
        );
      });
    } */

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const updateBatteryInfo = (battery) => {
    setBatteryInfo({
      level: Math.floor(battery.level * 100),
      charging: battery.charging,
    });
  };

  return (
    <div className="aspect-video bg-gray-100 relative">
      <video
        ref={videoRef}
        className="w-full h-full object-cover rounded-lg shadow-md"
        autoPlay
        playsInline
        muted
      />

      {/* Device Info Overlay */}
      <div className="absolute top-2 right-2 bg-black bg-opacity-50 rounded-lg p-2 text-white text-sm">
        {/* Battery Info */}
        {batteryInfo && (
          <div className="flex items-center mb-1">
            <Battery className="w-4 h-4 mr-1" />
            <div className="flex items-center">
              <span>{batteryInfo.level}%</span>
              {batteryInfo.charging && <span className="ml-1">⚡</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveCameraFeed;
